import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { 
  Modal, 
  ModalHeader, 
  ModalBody, 
  ModalFooter,
  UncontrolledButtonDropdown, 
  DropdownToggle, 
  DropdownMenu, 
  DropdownItem,
} from 'reactstrap';
import ReactNotification, {store} from 'react-notifications-component';
import { isEmptyObject } from 'jquery';
import { MODALACTION, RESPONSE } from '../../config/constants';
import Services from '../../services/service';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getMuiTheme, tableOptions } from '../../util/MuiTableTheme';

const { CREATE, EDIT, DELETE } = MODALACTION;
const { SUCCESS, FAILED, INVALID, EMAIL } = RESPONSE;
const validateMail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

class UserManagement extends Component {

  constructor(props){
    super(props);
    this.state = {
      modalAdd: false,
      username: '',
      fullname: '',
      nip: '',
      phone: '',
      position: '',
      status: '',
      role: '',
      actionModal: '',
      resetModal: false,
      showOTPModal: false,
      newPassword: '',
      selectedItem: {},
      dataUser: [],
      positionList: [],
      roleList: [],
      divisionList: [],
      division: '',
      genderList: [],
      gender: '',
      password: ''
    };
    this.initialState = this.state;
  }

  componentDidMount(){
    this.initiateData();
  };

  initiateData = () => {
    this.getDataUser();
    this.getDivisionList();
    this.getRoleList();
    this.getGender();
  };

  getDivisionList = () => {
    Services.getList({ param: 'division' })
      .then(res => {
        this.setState({ divisionList: res })
      })
      .catch(err => console.log(err));
  }

  addNotification = (notificationType, notificationTitle, notificationMessage, notificationPosition) => {
    store.addNotification({
      title: notificationTitle,
      message: notificationMessage,
      type: notificationType,
      insert: "top",
      container: notificationPosition,
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 2000 },
      dismissable: { click: true }
    });
  }

  toggleNotification = action => {
    switch(action){
      case SUCCESS:
        this.addNotification('success', 'Success', 'All your data has been successfully updated', 'top-right');
        break;
      case FAILED:
        this.addNotification('danger', 'Danger', 'Oops something went wrong !', 'top-right');
        break;
      case INVALID:
        this.addNotification('danger', 'Invalid Format', 'This field must be a number', 'top-right');
        break;
      case EMAIL:
        this.addNotification('danger', '', 'Please input valid email', 'top-right');
        break;
      default:
        break;
    }
  };

  getDataUser = () => {
    Services.getUserList()
      .then(res => {
        this.setState({ dataUser: res });
      })
      .catch(err => console.log(err))
  };

  getRoleList = () => {
    Services.getAllRoleAccess()
      .then(res => {
        this.setState({ roleList: res });
      })
      .catch(err => {console.log(err)});
  };

  getGender = () => {
    Services.getList({ param: 'gender' })
      .then(res => {
        this.setState({ genderList: res });
      })
      .catch(err => {console.log(err)});
  };

  handleDeleteData = () => {
    const { selectedItem } = this.state;
    const payload = selectedItem._id;
    Services.deleteUser(payload)
      .then(res => {
        this.setState({modalAdd: false});
        this.toggleNotification(SUCCESS);
        this.initiateData();
      })
      .catch(err => {
        console.log(err);
        this.setState({modalAdd: false});
        this.toggleNotification(FAILED);
      });
  };

  handleResetData = () => {
    this.setState({
      username: '',
      fullname: '',
      nip: '',
      phone: '',
      position: '',
      status: '',
      role: '',
      gender: '',
      newPassword:'',
    })
  };

  handleUpdateData = () => {
    const { selectedItem, username, fullname, position, role, nip, phone, password, gender, division } = this.state;
    const param = { params: { userId: selectedItem._id }};
    const payload = {
      username: username ? username : selectedItem.username,
      fullname: fullname ? fullname : selectedItem.fullname,
      division: division ? division : selectedItem.division,
      position: position ? position : selectedItem.position,
      role: role ? role : selectedItem.role,
      nip: nip ? nip : selectedItem.nip,
      phone: phone ? phone : selectedItem.phone,
      password: password ? password : selectedItem.password,
      gender: gender ? gender: selectedItem.gender
    };
    if (!validateMail.test(payload.username)) {
      this.toggleNotification(EMAIL)
    } else {
      Services.updateUser(payload, param)
        .then(res => {
          this.setState(this.initialState);
          this.toggleNotification(SUCCESS);
          this.initiateData();
        })
        .catch(err => {
          console.log(err);
          this.setState({modalAdd: false});
          this.toggleNotification(FAILED);
        });
    }
  };

  handleSubmitData = () => {
    const { username, fullname, position, role, gender, nip, phone, division } = this.state;
    const payload = {
      username,
      fullname,
      division,
      position,
      role,
      gender,
      nip,
      phone
    };
    if (!validateMail.test(payload.username)) {
      this.toggleNotification(EMAIL)
    } else {
      Services.postUser(payload)
        .then(res => {
          this.setState(this.initialState);
          this.toggleNotification(SUCCESS);
          this.initiateData();
        })
        .catch(err => {
          console.log(err);
          this.setState({ modalAdd: false });
          this.toggleNotification(FAILED);
        });
    }
  };

  handleResetPassword = () => {
    const { selectedItem, newPassword } = this.state;
    const payload = {
      username: selectedItem.username,
      newPassword
    };

    Services.postResetPassword(payload)
      .then(res => {
        this.setState(this.initialState);
        this.toggleNotification(SUCCESS);
        this.initiateData();
      })
      .catch(err => {
        console.log(err);
        this.setState({ modalAdd: false });
        this.toggleNotification(FAILED);
      });
  }

  handleFieldChange = (key) => (e) => {
    const re = /^[0-9\b]+$/;
    if(key === "phone") {
      if (e.target.value === "" || re.test(e.target.value)) {
        const state = { [key]: e.target.value };
        this.setState(state);
      } else {
        this.toggleNotification(INVALID)
      }
    } else if(key === "division") {
        this.state.divisionList.forEach(function (item) {
        if(e.target.value === item.id) {
          this.setState({ positionList : item.options })
        }
      }.bind(this));
      const state = { [key]: e.target.value };
      this.setState(state);
    } else {
      const state = { [key]: e.target.value };
      this.setState(state);
    }
  };

  renderBreadcrumb = () => (
    <div>
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
        <li className="breadcrumb-item active">User Management</li>
      </ol>
      <h1 className="page-header">User Management</h1>
    </div>
  );

  renderTableUser = () => {
    const { dataUser } = this.state;
    const columns = [
      {
        name: "no",
        label: "No",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1
        }
      },
      {
        name: "username",
        label: "User Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "fullname",
        label: "Full Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "positionName",
        label: "Position",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "roleName",
        label: "Role",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
          customBodyRender: value => value === 0 ? 'New' : value === 1 ? 'Active' : 'Inactive'
        }
      },
      {
        name: "_id",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          setCellProps: () => ({ style: { minWidth: "200px", maxWidth: "200px" }}),
          customBodyRender: (value) => {
            return (
              <UncontrolledButtonDropdown direction="down" className="me-2 mb-1">
                <DropdownToggle color="primary" className="dropdown-toggle btn-sm">AKSI </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    onClick={() => {
                      const selectedData = dataUser.find(item => item._id === value);
                      this.setState({
                        selectedItem: selectedData,
                        resetModal: true,
                      });
                    }}
                  > RESET PASSWORD
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => this.toggleAddModal(EDIT, value)}
                    className="text-blue"
                  > {EDIT}
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => this.toggleAddModal(DELETE, value)}
                    className="text-danger"
                  > {DELETE}
                  </DropdownItem>
                  <DropdownItem divider></DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      const selectedData = dataUser.find(item => item._id === value);
                      this.setState({
                        selectedItem: selectedData,
                        showOTPModal: true,
                      });
                    }}
                    className="text-success"
                  > SHOW OTP
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            );
          }
        }
      }
    ];

    const options = {
      ...tableOptions,
      customToolbar: () => (
        <button className="btn btn-sm btn-primary width-70" onClick={() => this.toggleAddModal(CREATE)}>Add</button>
      ),
    };

    return (
      <MuiThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={"List User"}
          data={dataUser}
          columns={columns}
          options={options}
        />
      </MuiThemeProvider>
    )
  };

  //Start Modal Method

  toggleAddModal = async (action = '', value = '') => {
    const { dataUser } = this.state;
    const selectedData = await dataUser.find(item => item._id === value);
    // console.log('selectedData', selectedData);
    let positionList = [];
    if ((action === EDIT) || (action === DELETE)){
      positionList = selectedData?.positionList.length > 0
      && selectedData.positionList[0].position.map((item, i) => {
        return ({value: item.id, label: item.name})
      });
    }

    this.setState({
      modalAdd: !this.state.modalAdd,
      actionModal: action,
      selectedItem: selectedData,
      positionList: positionList
    }, () => this.renderAddUserModal());
  };
  

  renderAddUserModal = () => {
    const {
      actionModal, selectedItem, username, fullname, positionList, roleList, genderList,
      division, divisionList, nip, phone, position, role, gender }
      = this.state;

    const formData = [username, fullname, nip, phone, position, gender, role];
    const disabled = formData.includes('');
    const textHeader = this.setHeaderItemText(actionModal);
    const filled = isEmptyObject(selectedItem);
    const divisionOption = divisionList.length > 0
      && divisionList.map((item, i) => {
        return (
          <option key={i} value={item.id}>{item.label}</option>
        )
      });

    const positionOption = positionList.length > 0
      && positionList.map((item, i) => {
        return (
          <option key={i} value={item.value}>{item.label}</option>
        )
      }, this);

    const roleOption = roleList.length > 0
      && roleList.map((item, i) => {
        return (
          <option key={i} value={item._id}>{item.roleName}</option>
        )
      }, this);
    const genderOption = genderList.length > 0
      && genderList.map((item, i) => {
        return (
          <option key={i} value={item.id}>{item.name}</option>
        )
      }, this);

    return (
      <Modal isOpen={this.state.modalAdd} toggle={() => this.toggleAddModal()}>
        <ModalHeader toggle={() => this.toggleAddModal()}>{textHeader}</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>User Name</label>
            <input
              onChange={this.handleFieldChange('username')}
              type="text"
              className="form-control"
              defaultValue={!filled ? selectedItem?.username : username}
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>Full Name</label>
            <input
              onChange={this.handleFieldChange('fullname')}
              type="text" className="form-control"
              defaultValue={!filled ? selectedItem?.fullname : fullname }
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>NIP</label>
            <input
              onChange={this.handleFieldChange('nip')}
              type="text" className="form-control"
              defaultValue={!filled ? selectedItem?.nip : nip }
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input
              onChange={this.handleFieldChange('phone')}
              type="text" className="form-control"
              defaultValue={!filled ? selectedItem.phone : phone }
              disabled={actionModal === DELETE}
            />
          </div>
          <div className="form-group">
            <label>Division</label>
            <select
              onChange={this.handleFieldChange('division')}
              type="select" className="form-control"
              defaultValue={!filled ? selectedItem.division : division}
              disabled={actionModal === DELETE}
            >
              <option disabled value=''> - pilih - </option>
              {divisionOption}
            </select>
          </div>
          <div className="form-group">
            <label>Position</label>
            <select
              onChange={this.handleFieldChange('position')}
              type="select" className="form-control"
              defaultValue={!filled ? selectedItem.position : position }
              disabled={actionModal === DELETE}
            >
              <option disabled value=''> - pilih - </option>
              {positionOption}
            </select>
          </div>
          <div className="form-group">
            <label>Gender</label>
            <select
              onChange={this.handleFieldChange('gender')}
              type="select" className="form-control"
              defaultValue={!filled ? selectedItem.gender : gender }
              disabled={actionModal === DELETE}
            >
              <option disabled value=''> - pilih - </option>
              {genderOption}
            </select>
          </div>
          <div className="form-group">
            <label>Role</label>
            <select
              onChange={this.handleFieldChange('role')}
              type="select" className="form-control"
              defaultValue={!filled ? selectedItem.role : role }
              disabled={actionModal === DELETE}
            >
              <option disabled value=''> - pilih - </option>
              {roleOption}
            </select>
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-aqua" onClick={() => this.handleResetData()}>Clear</button>
          <button className="btn btn-white" onClick={() => this.toggleAddModal()}>Cancel</button>
          <button
            className="btn btn-primary"
            disabled={actionModal===CREATE && disabled}
            onClick={()=> this.setActionButton(actionModal)}
          >
            {actionModal}
          </button>
        </ModalFooter>
      </Modal>
    )
  };

  renderResetModal = () => {
    const { resetModal, newPassword, selectedItem } = this.state;
    return (
      <Modal isOpen={resetModal} toggle={() => this.setState({ resetModal: false })}>
        <ModalHeader toggle={() => this.setState({ resetModal: false })}>Reset Password</ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label>User Name</label>
            <input
              onChange={this.handleFieldChange('username')}
              type="text"
              className="form-control"
              defaultValue={selectedItem?.username}
              disabled
            />
          </div>
          <div className="form-group">
            <label>New Password</label>
            <input
              onChange={this.handleFieldChange('newPassword')}
              type="text" className="form-control"
              defaultValue={newPassword}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-aqua" onClick={() => this.handleResetData()}>Clear</button>
          <button className="btn btn-white" onClick={() => this.setState({ resetModal: false })}>Cancel</button>
          <button
            className="btn btn-primary"
            onClick={this.handleResetPassword}
          >
            Submit
          </button>
        </ModalFooter>
      </Modal>
    )
  }

  setHeaderItemText = (value) => {
    switch (value) {
      case CREATE :
        return 'Add User';
      case EDIT :
        return 'Edit User';
      case DELETE :
        return 'Are you sure want to delete ?';
      default:
        return '';
    }
  }

  setActionButton = (value) => {
    switch (value) {
      case CREATE :
        this.handleSubmitData();
        break;
      case EDIT :
        this.handleUpdateData();
        break;
      case DELETE :
        this.handleDeleteData();
        break;
      default:
        break;
    }
  }

  renderOTPModal = () => {
    const { showOTPModal, selectedItem } = this.state;
    return (
      <Modal isOpen={showOTPModal} toggle={() => this.setState({ showOTPModal: false })} centered>
        <ModalHeader toggle={() => this.setState({ showOTPModal: false })}>OTP</ModalHeader>
        <ModalBody>
          <div className='f-s-64 text-center'>
            {selectedItem.securityCode}
          </div>
        </ModalBody>
      </Modal>
    )
  }
  //End Modal Method

  render() {
    return (
      <div>
        <ReactNotification/>
        {this.renderBreadcrumb()}
        <div>
          {this.renderTableUser()}
        </div>
        {this.renderAddUserModal()}
        {this.renderResetModal()}
        {this.state.showOTPModal && this.renderOTPModal()}
      </div>
    )
  }
}

export default UserManagement;
